import { Column } from '@melements/front-components';
import styled from 'theme';

export const TppsWrapper = styled.div``;

export const LeftModalColumn = styled(Column)`
  border-right: 2px solid #142897;
`;

export const RightModalColumn = styled(Column)`
  color: ${p => p.theme.variables.customColors.leadingColor.base};
  font-size: ${p => p.theme.variables.fonts.size.base};
`;
